import React, { createContext, useContext, useState, ReactNode } from 'react';

type ContextType<T> = [T | null, React.Dispatch<React.SetStateAction<T | null>>];

export function createGenericContext<T>() {
    const context = createContext<ContextType<T> | undefined>(undefined);

    const Provider = ({ children }: { children: ReactNode }) => {
        const state = useState<T | null>(null);
        return <context.Provider value={state}>{children}</context.Provider>;
    };

    const useGenericContext = (): ContextType<T> => {
        const contextValue = useContext(context);
        if (!contextValue) {
            throw new Error('useGenericContext must be used within a Provider');
        }
        return contextValue;
    };

    return [useGenericContext, Provider] as const;
} 